import {
    GREEN_CARD,
    PLATINUM_CARD,
    YELLOW_CARD,
    QUICK_CASH,
    PBP,
    DEPOSIT_CREDIT_ORDINARY,
    BUSINESS_CREDIT_LINE,
    BUSINESS_A_EXPRESS,
    DEPOSIT_CREDIT,
    BUSINESS_RKO,
    BUSINESS_DEPOSITS,
    BUSINESS_GUARANTEES,
    ABANK24,
    PAYMENTS,
    DOCUMENTS,
    SERVICES_TRANSFERS,
    SAFE_BOXES,
    SERVICE_LEASING,
    INSURANCE,
    BUSINESS_ACQUIRING,
    BUSINESS_VED_CONTRACT,
    PENSION,
    PBP_ENTITY,
    PESSONAL_DATA,
    BENEFITS_MILITARY_PERSONNEL,
    ACCEPTING_PAYMENTS,
    BUSINESS_COLLECTION,
    PAYMENT_BY_PHONE,
    ABROAD,
    WAR_TIME,
    TRANSFER_BONUS,
    ONLINE_DEPOSIT,
    FGVO,
    CALCULATOR_DEPOSIT,
    TARIFFS_DEPOSIT,
    REPAIR_CARD,
    INSTALLMENT_FROM_STATEMENT,
    BUSINESS_FOP,
    BUSINESS_YUO,
    KID_CARD,
    CASHBACK,
    TERMINALS,
    VYGODA_INSTALLMENT,
    BUSINESS_GOV,
    CASHBACK_UA,
    INVITE_FRIEND,
    CARDS_DESIGN,
    ENERGY_ALL_NEW,
    BUSINESS_SALARY_PROJECT_NEW,
    CARDS_NEW,
    CREDITS,
    QUICK_CASH_PLUS,
    BUSINESS_ABUSINESS_NEW,
    DEPOSITS_NEW,
    HELP_DEPOSIT,
    DIIA_CARD_NEW,
    BROKERAGE_SERVICES,
    QUICK_CASH_SALARY_PLUS,
    QUICK_CASH_ZERO,
    RESTRUCTURING,
    FIN_MON,
    INSTANT_CASH,
    MONEY_AUTO,
    BUSINESS_POS_TERMINALS,
    BUSINESS_INTERNET_ACQUIRING,
    BUSINESS_MOBILE_TERMINAL,
    BUSINESS_QR_ACQUIRING,
    BUSINESS_VENDING,
    BUSINESS_DEPOSITS_OVER,
    BUSINESS_DEPOSITS_PERCENT,
    BUSINESS_GOV_FRP,
    BUSINESS_GOV_GUARANTEES,
    BUSINESS_GOV_ECA,
    BUSINESS_GOV_KMDA,
    BUSINESS_GOV_APC,
    BUSINESS_CASH_PROCEEDS,
    BUSINESS_LOANS_CORPORATE_CLIENTS,
    BUSINESS_GOV_RECEIPT,
    BUSINESS_QUICK_CASH_INDIVIDUAL,
    BUSINESS_QUICK_CASH_BUSINESS,
    BUSINESS_QUICK_CASH,
    BUSINESS_GOV_LIGHT_HOUSE,
    BUSINESS_EXPRESS_PARTNER,
    BUSINESS_GOV_LEASING
} from '../Breadcrumbs/collection/breadcrumbs.config.js';

export const list = {
    subMenuCards: [
        {title: GREEN_CARD.title, url: GREEN_CARD.link},
        {title: YELLOW_CARD.title, url: YELLOW_CARD.link},
        {title: KID_CARD.title, url: KID_CARD.link},
        {title: PLATINUM_CARD.title, url: PLATINUM_CARD.link},
        {title: CARDS_NEW.title, url: CARDS_NEW.link}
    ],

    subMenuCards2: [
        {title: REPAIR_CARD.title, url: REPAIR_CARD.link},
        {title: CASHBACK_UA.title, url: CASHBACK_UA.link},
        {title: DIIA_CARD_NEW.title, url: DIIA_CARD_NEW.link}
    ],

    subMenuCredit: [
        {title: PBP.title, url: PBP.link},
        {title: QUICK_CASH.title, url: QUICK_CASH.link},
        {title: INSTANT_CASH.title, url: INSTANT_CASH.link},
        {title: DEPOSIT_CREDIT_ORDINARY.title, url: DEPOSIT_CREDIT_ORDINARY.link},
        {title: INSTALLMENT_FROM_STATEMENT.title, url: INSTALLMENT_FROM_STATEMENT.link},
        {title: VYGODA_INSTALLMENT.title, url: VYGODA_INSTALLMENT.link},
        {title: RESTRUCTURING.title, url: RESTRUCTURING.link},
        {title: CREDITS.title, url: CREDITS.link}
    ],

    subMenuCredit2: [
        {title: QUICK_CASH_SALARY_PLUS.title, url: QUICK_CASH_SALARY_PLUS.link},
        {title: QUICK_CASH_PLUS.title, url: QUICK_CASH_PLUS.link},
        {title: QUICK_CASH_ZERO.title, url: QUICK_CASH_ZERO.link}
    ],

    subMenuBusiness: [
        {title: BUSINESS_FOP.title, url: BUSINESS_FOP.link},
        {title: BUSINESS_YUO.title, url: BUSINESS_YUO.link},
        {title: BUSINESS_ACQUIRING.title, url: BUSINESS_ACQUIRING.link},
        {title: BUSINESS_SALARY_PROJECT_NEW.title, url: BUSINESS_SALARY_PROJECT_NEW.link},
        {title: ACCEPTING_PAYMENTS.title, url: ACCEPTING_PAYMENTS.link},
        {title: BUSINESS_COLLECTION.title, url: BUSINESS_COLLECTION.link}
    ],

    subMenuBusiness2: [
        {title: BUSINESS_A_EXPRESS.title, url: BUSINESS_A_EXPRESS.link},
        {title: BUSINESS_CREDIT_LINE.title, url: BUSINESS_CREDIT_LINE.link},
        {title: BUSINESS_RKO.title, url: BUSINESS_RKO.link},
        {title: DEPOSIT_CREDIT.title, url: DEPOSIT_CREDIT.link},
        {title: ENERGY_ALL_NEW.title, url: ENERGY_ALL_NEW.link},
        {title: BUSINESS_GOV.title, url: BUSINESS_GOV.link},
        {title: BUSINESS_EXPRESS_PARTNER.title, url: BUSINESS_EXPRESS_PARTNER.link},
        {title: BUSINESS_LOANS_CORPORATE_CLIENTS.title, url: BUSINESS_LOANS_CORPORATE_CLIENTS.link},
        {
            title: BUSINESS_QUICK_CASH_INDIVIDUAL.title,
            url: BUSINESS_QUICK_CASH.link
        }
    ],

    subMenuBusiness3: [
        {title: BUSINESS_ABUSINESS_NEW.title, url: BUSINESS_ABUSINESS_NEW.link},
        {title: BUSINESS_DEPOSITS.title, url: BUSINESS_DEPOSITS.link},
        {title: BUSINESS_VED_CONTRACT.title, url: BUSINESS_VED_CONTRACT.link},
        {title: BUSINESS_GUARANTEES.title, url: BUSINESS_GUARANTEES.link},
        {title: PBP_ENTITY.title, url: PBP_ENTITY.link},
        {title: FIN_MON.title, url: FIN_MON.link}
    ],

    subMenuServices: [
        {title: ABANK24.title, url: ABANK24.link},
        {title: PAYMENTS.title, url: PAYMENTS.link},
        {title: SERVICES_TRANSFERS.title, url: SERVICES_TRANSFERS.link},
        {title: PENSION.title, url: PENSION.link},
        {title: INSURANCE.title, url: INSURANCE.link},
        {title: SAFE_BOXES.title, url: SAFE_BOXES.link},
        {title: INVITE_FRIEND.title, url: INVITE_FRIEND.link},
        {title: CARDS_DESIGN.title, url: CARDS_DESIGN.link},
        {title: PAYMENT_BY_PHONE.title, url: PAYMENT_BY_PHONE.link}
    ],

    subMenuServices2: [
        {title: DOCUMENTS.title, url: DOCUMENTS.link},
        {title: PESSONAL_DATA.title, url: PESSONAL_DATA.link},
        {title: BENEFITS_MILITARY_PERSONNEL.title, url: BENEFITS_MILITARY_PERSONNEL.link}
    ],

    subMenuServices3: [
        {title: SERVICE_LEASING.title, url: SERVICE_LEASING.link},
        {title: MONEY_AUTO.title, url: MONEY_AUTO.link},
        {title: TERMINALS.title, url: TERMINALS.link},
        {title: ABROAD.title, url: ABROAD.link},
        {title: WAR_TIME.title, url: WAR_TIME.link},
        {title: CASHBACK.title, url: CASHBACK.link},
        {title: BROKERAGE_SERVICES.title, url: BROKERAGE_SERVICES.link},
        {title: BUSINESS_GOV_RECEIPT.title, url: BUSINESS_GOV_RECEIPT.link}
    ],

    subMenuDeposits: [
        {title: TRANSFER_BONUS.title, url: TRANSFER_BONUS.link},
        {title: ONLINE_DEPOSIT.title, url: ONLINE_DEPOSIT.link},
        {title: HELP_DEPOSIT.title, url: HELP_DEPOSIT.link},
        {title: DEPOSITS_NEW.title, url: DEPOSITS_NEW.link}
    ],

    subMenuDeposits2: [
        {title: CALCULATOR_DEPOSIT.title, url: CALCULATOR_DEPOSIT.link},
        {title: TARIFFS_DEPOSIT.title, url: TARIFFS_DEPOSIT.link},
        {title: FGVO.title, url: FGVO.link}
    ]
};

export const businessList = {
    subMenuBusinessCalculations: [
        {title: BUSINESS_YUO.title, url: BUSINESS_YUO.link},
        {title: BUSINESS_FOP.title, url: BUSINESS_FOP.link},
        {title: BUSINESS_SALARY_PROJECT_NEW.title, url: BUSINESS_SALARY_PROJECT_NEW.link},
        {title: ACCEPTING_PAYMENTS.title, url: ACCEPTING_PAYMENTS.link},
        {title: BUSINESS_VED_CONTRACT.title, url: BUSINESS_VED_CONTRACT.link}
    ],

    subMenuBusinessTrade: [
        {title: BUSINESS_POS_TERMINALS.title, url: BUSINESS_POS_TERMINALS.link},
        {title: BUSINESS_INTERNET_ACQUIRING.title, url: BUSINESS_INTERNET_ACQUIRING.link},
        {title: BUSINESS_MOBILE_TERMINAL.title, url: BUSINESS_MOBILE_TERMINAL.link},
        {title: BUSINESS_QR_ACQUIRING.title, url: BUSINESS_QR_ACQUIRING.link},
        {title: BUSINESS_VENDING.title, url: BUSINESS_VENDING.link},
        {title: BUSINESS_CASH_PROCEEDS.title, url: BUSINESS_CASH_PROCEEDS.link},
        {title: BUSINESS_COLLECTION.title, url: BUSINESS_COLLECTION.link},
        {title: PBP_ENTITY.title, url: PBP_ENTITY.link}
    ],

    subMenuBusinessFreeMoney: [
        {title: BUSINESS_DEPOSITS.title, url: BUSINESS_DEPOSITS.link},
        {title: BUSINESS_DEPOSITS_OVER.title, url: BUSINESS_DEPOSITS_OVER.link},
        {title: BUSINESS_DEPOSITS_PERCENT.title, url: BUSINESS_DEPOSITS_PERCENT.link}
    ],

    subMenuBusinessFinancing: [
        {title: ENERGY_ALL_NEW.title, url: ENERGY_ALL_NEW.link},
        {title: BUSINESS_A_EXPRESS.title, url: BUSINESS_A_EXPRESS.link},
        {title: BUSINESS_CREDIT_LINE.title, url: BUSINESS_CREDIT_LINE.link},
        {title: BUSINESS_RKO.title, url: BUSINESS_RKO.link},
        {title: DEPOSIT_CREDIT.title, url: DEPOSIT_CREDIT.link},
        {title: BUSINESS_GUARANTEES.title, url: BUSINESS_GUARANTEES.link},
        {title: BUSINESS_EXPRESS_PARTNER.title, url: BUSINESS_EXPRESS_PARTNER.link},
        {title: BUSINESS_LOANS_CORPORATE_CLIENTS.title, url: BUSINESS_LOANS_CORPORATE_CLIENTS.link},
        {
            title: BUSINESS_QUICK_CASH_BUSINESS.title,
            url: BUSINESS_QUICK_CASH.link
        }
    ],

    subMenuBusinessGov: [
        {title: BUSINESS_GOV_FRP.title, url: BUSINESS_GOV_FRP.link},
        {title: BUSINESS_GOV_GUARANTEES.title, url: BUSINESS_GOV_GUARANTEES.link},
        {title: BUSINESS_GOV_APC.title, url: BUSINESS_GOV_APC.link},
        {title: BUSINESS_GOV_KMDA.title, url: BUSINESS_GOV_KMDA.link},
        {title: BUSINESS_GOV_ECA.title, url: BUSINESS_GOV_ECA.link},
        {title: BUSINESS_GOV_LIGHT_HOUSE.title, url: BUSINESS_GOV_LIGHT_HOUSE.link},
        {title: BUSINESS_GOV_LEASING.title, url: BUSINESS_GOV_LEASING.link}
    ]
};
